/**
 * 🚀 AUDIT FIX: Toast wrapper simplificado
 * 
 * ANTES: Dois sistemas (Radix Toast + Sonner)
 * DEPOIS: Apenas Sonner com interface simplificada
 * 
 * Para toasts com Brand Assets, use:
 * import { auliToast } from "@/components/ui/auli-toast";
 */
import { toast as sonnerToast } from 'sonner';

export interface ToastOptions {
  title?: string;
  description?: string;
  variant?: 'default' | 'destructive';
  duration?: number;
}

/**
 * Função de toast compatível com o código existente
 * 
 * Para toasts com Brand Emojis da Auli, use auliToast:
 * @example
 * import { auliToast } from "@/components/ui/auli-toast";
 * auliToast.success({ title: "Aula agendada!" });
 * auliToast.error({ title: "Oops!", description: "Algo deu errado" });
 */
export function toast({ title, description, variant, duration }: ToastOptions) {
  if (variant === 'destructive') {
    sonnerToast.error(title || description || 'Erro', {
      description: description || undefined,
      duration,
    });
    return { id: Date.now().toString(), dismiss: () => sonnerToast.dismiss() };
  }
  
  if (description) {
    sonnerToast(title || 'Notificação', { description, duration });
  } else {
    sonnerToast(title || 'Notificação', { duration });
  }
  
  return { id: Date.now().toString(), dismiss: () => sonnerToast.dismiss() };
}

/**
 * Hook compatível com a API antiga
 */
export function useToast() {
  return {
    toast,
    dismiss: (id?: string) => id ? sonnerToast.dismiss(id) : sonnerToast.dismiss(),
  };
}

// Re-export auliToast para facilitar importação
export { auliToast } from "@/components/ui/auli-toast";

